import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eEstadoFichaSso, eTypeResult, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IPeriodicElement } from 'src/app/models/common/PeriodicElement';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FichaSsoModel } from 'src/app/models/ficha-sso/FichaSsoModel';
import { FilterFichaSsoModel } from 'src/app/models/ficha-sso/FilterFichaSsoModel';
import { IFilterFichaSsoModel } from 'src/app/models/interfaces/ficha-sso/IFilterFichaSsoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { FichaSsoService } from 'src/app/services/ficha-sso/ficha-sso.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SsoSolicitarAmpliacionComponent } from '../../ampliacion/sso-solicitar-ampliacion/sso-solicitar-ampliacion.component';
import { HttpEventType } from '@angular/common/http';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';


@Component({
  templateUrl: './sso-contratista-listar.component.html',
  styleUrls: ['./sso-contratista-listar.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SsoContratistaListarComponent implements OnInit {
  model: IFilterFichaSsoModel;
  listaFichas: FichaSsoModel[] = new Array<FichaSsoModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaAnios: Number[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  meses: Mes[] = [
    { value: '1', viewValue: 'Enero' },
    { value: '2', viewValue: 'Febrero' },
    { value: '3', viewValue: 'Marzo' },
    { value: '4', viewValue: 'Abril' },
    { value: '5', viewValue: 'Mayo' },
    { value: '6', viewValue: 'Junio' },
    { value: '7', viewValue: 'Julio' },
    { value: '8', viewValue: 'Agosto' },
    { value: '9', viewValue: 'Setiembre' },
    { value: '10', viewValue: 'Octubre' },
    { value: '11', viewValue: 'Noviembre' },
    { value: '12', viewValue: 'Diciembre' },
  ];

  @ViewChild('paginator') paginator!: MatPaginator;
  resultsLength = 0;
  currentPage = 0;
  huboAccidentes = true;
  displayedColumns: string[] = ['anio', 'mes', 'compania', 'sede', 'fechalimite', 'estado', 'acciones'];
  columnsToDisplayWithExpand = ['expand', ...this.displayedColumns];
  expandedElement!: IPeriodicElement | null;
  currentCalendar: CalendarioSsoModel;

  constructor(
    private storage: StorageService,
    public dialog: MatDialog,
    private parametroService: ParametroService,
    private calendarioService: CalendarioSsoService,
    private alertDialogService: AlertDialogService,
    private sedeService: SedeService,
    private service: FichaSsoService) {
    this.model = new FilterFichaSsoModel();
    this.listaAnios = new Array<number>();
    this.model.pageSize = 30;
    this.currentCalendar = new CalendarioSsoModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.calendarioService.getAnios()
      .subscribe((data: number[]) => {
        this.listaAnios = data;
      });

    this.parametroService
      .getDetalles(ParametrosMaestro.ESTADOS_FICHA_SSO)
      .subscribe((p) => {
        this.listaEstados = p.items;
      });

    this.companiaChanged();

    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });


    this.calendarioService.getCurrent(this.model.idCompania)
      .subscribe((data: CalendarioSsoModel) => {
        this.currentCalendar = data;
        if (data.mes > 0) {
          this.model.meses = [`${data.mes}`];
          this.model.anio = data.anio;
        }

        //this.search();
      });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }

  allowedChars: number[] = [37, 39, 46];

  check(event: KeyboardEvent, value: string, maxLength: number) {
    if (event.keyCode > 31 && !this.allowedChars.includes(event.keyCode) && value && value.toString().length + 1 > maxLength) {
      event.preventDefault();
    }
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getListContratista(this.model)
      .subscribe((data: SearchResultModel<FichaSsoModel[]>) => {
        this.listaFichas = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
        if (data.total == 0)
          this.alertDialogService.open('No se encontraron registros que concuerden con los filtros de búsqueda o El mes seleccionado no se encuentra activo.');
      });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service
      .getListContratistaToExport(this.model)
      .subscribe(data => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = data.body;// new Blob([data.body], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `indicadores-sso-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      }, error => {
        //  this.isImageLoading = false;
        //  console.log(error);
      });
  }

  saveFicha(element: FichaSsoModel) {

  }

  onSubmit(form: NgForm, element: FichaSsoModel) {

    if (!form.invalid) {

      if (element.avancePasst != null && element.avancePasst > 100) {
        this.alertDialogService.open('El porcentaje de Avance PASST debe ser menor o igual a 100.');
      }
      else if (element.rutaArchivo == null || element.rutaArchivo == '') {
        this.alertDialogService.open('Debe adjuntar su Ficha SSO.');
      }
      else {
        element.idEstado = eEstadoFichaSso.Completado;
        this.service.update(element).subscribe((result: ActionResultModel) => {
          console.log(result);
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          } else {
            this.alertDialogService.open('Se registró su información.');
            this.search();
          }
        }, error => {
          //console.log('oops', error)
          this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador. Detalle: ${error.title}.`)
        });
      }
    }
    else {
      this.alertDialogService.open('Complete los campos obligatorios.');
    }
  }

  openDialogAmpliacion(item: FichaSsoModel): void {


    const dialogRef = this.dialog.open(SsoSolicitarAmpliacionComponent, {
      width: '1000px',
      data: item,
    });

    dialogRef.afterClosed().subscribe((result: FichaSsoModel) => {
      if (result)
        this.search();
    });
  }

  public uploadFile = (files: any, element: FichaSsoModel) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service
      .upload(formData, element.idFichaSso, this.model.anio.toString())
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          // this.progress = Math.round(100 * event.loaded / event.total);
        } else if (event.type === HttpEventType.Response) {
          // this.filename = fileToUpload.name;
          // this.message = 'Upload success.';
          if (event.body) {
            const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body))
            element.nombreArchivo = doc.fileName;
            element.rutaArchivo = doc.dbPath;
          }
        }
      });
  }

  downloadDocumentFromService(element: FichaSsoModel) {
    //  this.isImageLoading = true;
    this.service.downloadDocumento(
      element.idFichaSso
    ).subscribe(data => {
      let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      //window.open(url);
      //window.location.href = response.url;
      fileSaver.saveAs(blob, element.nombreArchivo);

      //  this.createImageFromBlob(data);
      //  this.isImageLoading = false;
    }, error => {
      //  this.isImageLoading = false;
      //  console.log(error);
    });
  }
}

interface Mes {
  value: string;
  viewValue: string;
}